import { render, staticRenderFns } from "./modal-template-selector.vue?vue&type=template&id=1c814c40&"
import script from "./modal-template-selector.vue?vue&type=script&lang=js&"
export * from "./modal-template-selector.vue?vue&type=script&lang=js&"
import style0 from "./modal-template-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports